import { dataAcademicCapSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAcademicCapSolid = /*#__PURE__*/createIcon(dataAcademicCapSolid)
export default IconAcademicCapSolid
